'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIdentifiers = undefined;

var _storageKeys = require('./storageKeys');

var _messages = require('./common/messages');

var createIdentifiers = exports.createIdentifiers = function createIdentifiers(_ref, isExternalHost) {
  var email = _ref.email,
      userId = _ref.userId,
      hubId = _ref.hubId,
      hstc = _ref.hstc;

  var anonymousIdentifiers = void 0;
  var userIdentifier = void 0;

  if (email) {
    userIdentifier = 'EMAIL:::' + email + ':::' + _storageKeys.accountId;
  } else if (hstc) {
    anonymousIdentifiers = hstc.split('.');
    if (anonymousIdentifiers.length > 1) {
      var utk = anonymousIdentifiers[1];
      if (isExternalHost) {
        userIdentifier = 'TEMP_ID:::' + utk + ':::' + _storageKeys.accountId;
      } else {
        userIdentifier = 'VISITOR:::' + utk + ':::' + _storageKeys.accountId;
      }
    }
  }

  if (!userIdentifier) {
    throw (0, _messages.eventError)('Could not identify user. Please specify either an email or __hstc cookie identifer.');
  }

  return {
    user: userIdentifier,
    team: hubId,
    raw: {
      email: email,
      userId: userId,
      hubId: hubId,
      hstc: hstc
    }
  };
};